import * as z from "zod";

export const deleteIndigo8Integration = {
  name: "deleteIndigo8Integration" as const,
  input: z.object({}),
  output: z.object({}),
};
